import { Inbox } from "lucide-react";

export default function LeadsPanel({ items }) {
  if (!items) {
    return (
      <div className="border border-white/10 bg-[#0A0A0A] p-16 text-center text-zinc-500 text-sm">
        Loading custom quote leads…
      </div>
    );
  }
  if (items.length === 0) {
    return (
      <div data-testid="admin-empty-state" className="border border-white/10 bg-[#0A0A0A] p-16 text-center">
        <Inbox className="w-10 h-10 text-zinc-600 mx-auto" />
        <h3 className="font-display text-2xl font-bold mt-4">No custom quote requests yet.</h3>
        <p className="text-zinc-400 mt-2 text-sm">New activity will appear here in real time.</p>
      </div>
    );
  }
  return (
    <div className="border border-white/10 overflow-hidden" data-testid="admin-leads-list">
      {items.map((l) => (
        <div
          key={l.lead_id}
          data-testid={`admin-lead-${l.lead_id}`}
          className="px-6 py-5 border-b border-white/5 hover:bg-[#0A0A0A] grid grid-cols-1 md:grid-cols-3 gap-4"
        >
          <div>
            <div className="font-semibold">{l.customer_name}</div>
            <div className="text-zinc-500 text-xs mt-1">{l.customer_phone}</div>
            <div className="text-zinc-500 text-xs break-all">{l.customer_email}</div>
          </div>
          <div className="text-sm">
            <div>
              {l.journey?.pickup_location} → {l.journey?.dropoff_location}
            </div>
            <div className="text-zinc-500 text-xs mt-1">
              {l.vehicle?.make} {l.vehicle?.model} · {l.journey?.miles ?? 0} mi
            </div>
          </div>
          <div className="text-xs text-zinc-400">
            {(l.reasons || []).map((r, i) => (
              <div key={i}>· {r}</div>
            ))}
            {l.notes && <div className="italic mt-2 text-zinc-500">&ldquo;{l.notes}&rdquo;</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
